import { CHAT_TYPE, IGroupInfo, IUserInfo } from "@home-health-notify/domain";
import { IChatAccess, useTranslation } from "hhn-commons";

import {
  MessagePanelBannerContainer,
  MessagePanelBannerMessage,
} from "./MessagePanelBanner.style";

const MessagePanelBanner = ({ chatAccess }: { chatAccess: IChatAccess }) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "message" });

  const getBannerMessage = () => {
    if (chatAccess.getChatType() === CHAT_TYPE.PRIVATE) {
      const userInfo = chatAccess.chatInfo as IUserInfo;
      if (userInfo.onDNDMode) {
        return tNs("userOnDND");
      }
    }

    if (
      chatAccess.getChatType() === CHAT_TYPE.GROUP &&
      !!(chatAccess.chatInfo as IGroupInfo).settings
    ) {
      const settings = (chatAccess.chatInfo as IGroupInfo).settings;
      const visibleToPatient = settings?.visibleToPatient ?? false;
      const visibleToPhysician = settings?.visibleToPhysician ?? false;

      if (visibleToPatient && visibleToPhysician) {
        return tNs("visibleToPatientAndPhysician");
      } else if (visibleToPatient) {
        return tNs("visibleToPatient");
      } else if (visibleToPhysician) {
        return tNs("visibleToPhysician");
      }
    }
    return undefined;
  };

  const message = getBannerMessage();

  return (
    <>
      {!!message && (
        <MessagePanelBannerContainer>
          <MessagePanelBannerMessage>{message}</MessagePanelBannerMessage>
        </MessagePanelBannerContainer>
      )}
    </>
  );
};

export default MessagePanelBanner;
